module.exports = __webpack_public_path__ + "img/CheckMark.ce716df9.svg";